__turbopack_context__.v({
  "container": "alternate-redirect-module-scss-module__BNqQKa__container",
  "icon": "alternate-redirect-module-scss-module__BNqQKa__icon",
  "icon-container": "alternate-redirect-module-scss-module__BNqQKa__icon-container",
  "subtext": "alternate-redirect-module-scss-module__BNqQKa__subtext",
});
